<template>
  <div class="programme">
    <header id="header" class="animate__animated animate__zoomIn animate__slow">
      <img src="../assets/images/programme.jpg" alt="">
    </header><!-- /header -->

    <!-- 内容部分 -->
    <article class="introduce-con">

      <nav class="col-md-3 animate__animated animate__wobble animate__slow">
        <div>
          <h4>方案中心</h4>
          <hr class="hrs" />
          <p class="engsh">PROGRAMME</p>
        </div>

        <ul class="introduce-nav animate__animated animate__wobble animate__slow">
          <li v-bind:class="{'active':tabIndex==1}" @click="tabProgramme(1)"><a>成功案例</a></li>
          <hr class="hrs" />
          <li v-bind:class="{'active':tabIndex==2}" @click="tabProgramme(2)"><a>合作伙伴</a></li>
        </ul>
      </nav>
      <aside class="col-md-9 animate__animated animate__bounceInUp animate__slow">

        <div class="col-md-12 ">
          <h4 class="col-md-4 text-left">{{tabName}}</h4>

          <div class="col-md-8 text-right">
            <p>当前位置：首页 > 方案中心 > <span>{{tabName}}</span></p>
          </div>
          <div class="line"></div>
        </div>

        <div class="col-md-12 text-content">
          <!-- 地图 -->
          <!-- map -->
          <div class="baidumap" id="allmap"></div>
          <div class="contact-text">
            <h5>深圳市易联通达物流科技发展有限公司</h5>
            <p>Shenzhen E-link Logistics Technology Development Co,Ltd.</p>
            <p>电话：0755-86235167</p>
            <p>邮箱：223640822@qq.com</p>
            <p>地址：深圳市龙岗区平湖街道海源城国际金融中心T1栋1212-1213</p>
          </div>

        </div>
      </aside>
    </article>
  </div>
</template>

<script>
export default {
  name: "Programme",
  data() {
    return {
      tabIndex: 1,
      tabName: "成功案例",
    };
  },
  mounted() {
    this.baiduMap();
  },
  methods: {
    baiduMap() {
      var map = new window.BMap.Map("allmap"); //创建地图
      map.enableScrollWheelZoom(); //启用滚轮放大缩小
      var point = new window.BMap.Point(114.12883, 22.688615); //设置地图位置
      map.centerAndZoom(point, 12);
      var marker = new window.BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
    },
    tabProgramme(index) {
      this.tabIndex = index;
      if (index == 1) {
        this.tabName = "成功案例";
      } else if (index == 2) {
        this.tabName = "合作伙伴";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.line {
  width: 97%;
  height: 1px;
  background-color: #ededed;
  display: block;
  margin-top: 46px;
}
.texts {
  position: relative;
  line-height: 1.4em;
  /* 3 times the line-height to show 3 lines */
  height: 4.2em;
  overflow: hidden;
}
.texts::after {
  content: "";
  font-weight: bold;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 20px 1px 45px;
  background: url(http://newimg88.b0.upaiyun.com/newimg88/2014/09/ellipsis_bg.png)
    repeat-y;
}
a {
  text-decoration: none;
  color: #333;
}
a:hover {
  text-decoration: none;
  color: #333;
  cursor: pointer;
}
.programme .text-content {
  opacity: 0;
}
.baidumap {
  width: 98%;
  height: 210px;
  margin: 40px auto;
  margin-left: 15px;
}

/* 头部斑点图 */
#header img {
  width: 100%;
  height: 150px;
}

/*内容部分*/
.hrs {
  width: 80%;
  margin: 0 auto;
  height: 1px;
  border: 0;
  margin-bottom: 4px;
}
.introduce-con {
  width: 60%;
  margin: 20px auto;
}
.introduce-con nav {
  background-color: #ffffff;
  margin: 0;
  padding: 0;
  position: relative;
  top: -80px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
}
.engsh {
  margin-left: 10%;
}
.introduce-con nav ul {
  line-height: 40px;
}
.introduce-con nav div {
  background: #162987;
  color: #ffffff;
  text-align: left;
  padding: 10px 0;
}

.introduce-con nav div h4,
p {
  margin-left: 10%;
}
.introduce-con nav div hr {
  background-color: #2b3f96;
}
.introduce-nav hr {
  background-color: #ededed;
}
.introduce-nav .active a {
  color: #162987;
}
/*内容部分*/
.text-left {
  padding: 0;
  margin-bottom: 20px;
  vertical-align: middle;
  text-align: left;
}
.text-right p {
  text-align: right;
  margin-top: 12px;
  padding: 0;
  font-size: 12px;
  color: #b7b7b7;
}
.text-right p span {
  color: #414141;
}

/*内容主体*/
.contact-text {
  text-align: left;
}
.contact-text h5 {
  margin-left: 20px;
}
.contact-text p {
  font-size: 12px;
}
.contact-text {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Programme.vue